import MuiPopper, { PopperProps as MuiPopperProps } from '@material-ui/core/Popper';

export type DSPopperProps = MuiPopperProps;
export const DSPopper = MuiPopper;
